
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"currentColor","transform":"translate(-143.587 -635.755)"}},[_c('path',{attrs:{"d":"M161.633 641.755h-1.046v-1a1 1 0 00-2 0v1h-6v-1a1 1 0 00-2 0v1h-1.047a1.946 1.946 0 00-1.953 1.934v10.132a1.946 1.946 0 001.953 1.934h12.093a1.946 1.946 0 001.954-1.934v-10.132a1.946 1.946 0 00-1.954-1.934zm.837 12.066a.834.834 0 01-.837.829H149.54a.834.834 0 01-.837-.829v-10.132a.835.835 0 01.837-.83h1.068a.983.983 0 001.958 0h6.042a.983.983 0 001.958 0h1.067a.835.835 0 01.837.83z"}}),_c('circle',{staticClass:"prefix__cls-2",attrs:{"cx":"1","cy":"1","r":"1","data-name":"Ellipse 2058","transform":"translate(150.587 646.755)"}}),_c('circle',{staticClass:"prefix__cls-2",attrs:{"cx":"1","cy":"1","r":"1","data-name":"Ellipse 2059","transform":"translate(150.587 650.755)"}}),_c('circle',{staticClass:"prefix__cls-2",attrs:{"cx":"1","cy":"1","r":"1","data-name":"Ellipse 2060","transform":"translate(154.587 646.755)"}}),_c('circle',{staticClass:"prefix__cls-2",attrs:{"cx":"1","cy":"1","r":"1","data-name":"Ellipse 2061","transform":"translate(154.587 650.755)"}}),_c('circle',{staticClass:"prefix__cls-2",attrs:{"cx":"1","cy":"1","r":"1","data-name":"Ellipse 2062","transform":"translate(158.587 646.755)"}})])])
          )
        }
      }
    